import { useEffect, useRef } from 'react';

export default function useStickyOfferTable() {
  const headerRef = useRef(null);
  const rowRef = useRef(null);
  const tableRef = useRef(null);

  const handleScroll = () => {
    if (headerRef.current) {
      const header = headerRef.current;
      const headerRect = header.getBoundingClientRect();
      const table = tableRef.current;
      const tableRect = table.getBoundingClientRect();
      const rowHeight = rowRef.current.offsetHeight;
      const threeRows = rowHeight * 3;

      if (headerRect.top > tableRect.top + threeRows) {
        headerRef.current.style.marginBottom = `${threeRows}px`;
      } else {
        headerRef.current.style.marginBottom = '0px';
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return {
    tableRef,
    headerRef,
    rowRef,
  };
}
